import { render, staticRenderFns } from "./SubjectAreaTargetObjects.vue?vue&type=template&id=2450117a&"
import script from "./SubjectAreaTargetObjects.vue?vue&type=script&lang=ts&"
export * from "./SubjectAreaTargetObjects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports